// extracted by mini-css-extract-plugin
module.exports = {"background":"MensajeSuccess_background__WYted","image":"MensajeSuccess_image__2VnuE","main":"MensajeSuccess_main__9HXl0","text":"MensajeSuccess_text__1z_Nk"};